import React, { useState, useRef, useEffect } from "react";
import { FaChevronRight, FaEllipsisH, FaVideo } from "react-icons/fa";
import "./ChatHeader.css";
import MenuItems from "./MenuItems";
import { sendMessage } from "../../../components/Header/Data";
import { GetZoomLink } from "../../../components/Header/Data2";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import {
  addIncomingMessage,
  setSelectedConversation,
  setTypingStatus,
} from "../../../redux/slices/MsgSlice";
import { useSocket } from "../../../contexts/SocketContext";
import { Col, Row } from "reactstrap";
import AllDropdowns from "./AllDropDowns/DropDowns";
import { useSelector, useDispatch } from "react-redux";
import { getLastOnlineDisplay } from "../../../utils/OtherUtils";

const ChatHeader = ({ isMobileView, onBack, toggleDrawer, isChatModal }) => {
  const { sendNewMessage, socket } = useSocket();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const [zoomLink, setZoomLink] = useState("");
  const [loading, setLoading] = useState(false);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { selectedConvo } = useSelector((state) => state.messages);
  const { typingStatus } = useSelector((state) => state.messages);
  const { sampleAd } = useSelector((state) => state.searchBar);
  const { users } = useSelector((state) => state.socket);
  const allUsers = Array.isArray(users) ? users : [];
  const otherPartyId =
    selectedConvo?.createdBy == user?.UserID
      ? selectedConvo?.customerId
      : selectedConvo?.createdBy;
  const online = allUsers.some(
    (user) => user.Id === otherPartyId && user.onlineStatus === "online"
  );
  const otherUser = allUsers.find((user) => user.Id === otherPartyId);
  const otherUserStatus = otherUser?.onlineStatus || "offline";

  function formatDate1(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  // const formatLastOnline = (otherPartyId) => {
  //   const user = allUsers.find((user) => user.Id === otherPartyId);
  //   if (!user || !user.lastOnline) return "Unavailable";
  //   const lastOnlineDate = new Date(user.lastOnline);
  //   if (isNaN(lastOnlineDate.getTime())) return "Unavailable"; // Handle invalid date
  //   const now = new Date();
  //   const isToday = lastOnlineDate.toDateString() === now.toDateString();
  //   const isYesterday =
  //     new Date(now.setDate(now.getDate() - 1)).toDateString() ===
  //     lastOnlineDate.toDateString();
  //   if (isToday) {
  //     const hours = lastOnlineDate.getHours() % 12 || 12;
  //     const minutes = String(lastOnlineDate.getMinutes()).padStart(2, "0");
  //     const ampm = lastOnlineDate.getHours() >= 12 ? "PM" : "AM";
  //     return `${hours}:${minutes} ${ampm}`;
  //   } else if (isYesterday) {
  //     return "Yesterday";
  //   } else {
  //     const year = lastOnlineDate.getFullYear();
  //     const month = String(lastOnlineDate.getMonth() + 1).padStart(2, "0");
  //     const day = String(lastOnlineDate.getDate()).padStart(2, "0");
  //     return `${year}-${month}-${day}`;
  //   }
  // };
  const handleVideoClick = async () => {
    if (!selectedConvo) {
      toast.warning("Please send a message before starting a meeting");
      return;
    }
    setLoading(true);
    const formData = {
      startTime: formatDate1(new Date()),
      needName: selectedConvo?.postName,
      userTo:
        selectedConvo?.customerId === user?.UserID
          ? selectedConvo?.createdBy
          : selectedConvo?.customerId,

      userFrom:
        selectedConvo?.createdBy === user?.UserID
          ? selectedConvo?.createdBy
          : selectedConvo?.customerId,
      callType: 3, //1 for phone,2 for voip,3 for zoom
      userToPhone: "",
      userFromPhone: "",
      typeId: selectedConvo?.Id,
      Type: "messages",
    };
    try {
      const linkResponse = await GetZoomLink(formData, selectedConvo?.Id);
      setZoomLink(linkResponse.join_url);
      await handleSend(linkResponse.join_url);
    } catch (error) {
      console.error("Error fetching Zoom link:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async (zoomLink) => {
    if (zoomLink.trim()) {
      const messageForm = {
        customerId:
          selectedConvo.customerId === user.UserID
            ? selectedConvo.createdBy
            : selectedConvo.customerId,
        postId: selectedConvo.postId,
        postType: 1,
        parentId:
          selectedConvo.parentId === 0
            ? selectedConvo.Id
            : selectedConvo.parentId,
        Description: `Click to join zoom meeting <br/> <a href="${zoomLink}" target="_blank" style="padding: 5px 15px; border-radius: 6px; border: 1px solid; background-color: #0D6EFD; color: white;">Join Call</a>`,
        messageStatus: 8,
        createdBy: user.UserID,
        roleId: user.RoleId,
        ownerId: selectedConvo.ownerId,
        userName: user.UserName.split("@")[0].trim(),
        Email: user.Email,
        serviceNeed: "text",
        needName: selectedConvo.postName,
      };
      const response = await sendMessage(messageForm);
      toast.success("Zoom link sent");
      if (response.Data) {
        let data = response.Data;
        if (data.parentId == 0) {
          dispatch(setSelectedConversation(data));
        }
        sendNewMessage(response.Data);
        dispatch(addIncomingMessage(response.Data));
        toast.success("Message Sent");
      }
    }
    setZoomLink("");
  };
  useEffect(() => {
    const handleTypingResponse = (data) => {
      if (!data || !data.convoId) {
        dispatch(setTypingStatus("")); // Clear if null/stop signal
        return;
      }
      if (Number(data.userId) === Number(user?.UserID)) return; // Ignore self, with type coercion
      if (data.convoId !== selectedConvo?.Id) return;
      dispatch(setTypingStatus(`typing...`));
      // Clear after 1.5s (fallback if no stop signal)
      setTimeout(() => {
        dispatch(setTypingStatus(""));
      }, 1500);
    };

    socket.on("typingResponse", handleTypingResponse);

    // Cleanup: Remove the event listener when the component unmounts
    return () => {
      socket.off("typingResponse", handleTypingResponse);
    };
  }, [socket, user, selectedConvo, dispatch]);

  const OnlineIndicator = () => {
    return (
      <div className="online-indicator">
        <span
          className={`status-dot ${otherUserStatus}`}
          title={otherUserStatus}
        ></span>
        {otherUserStatus == "offline" && (
          <span className="last-online">
            {/* Last online: {formatLastOnline(otherPartyId)} */}
            Last online:{" "}
            {getLastOnlineDisplay(
              otherUser?.lastOnline,
              otherUser?.timeZone,
              user?.TimeZone
            )}
          </span>
        )}
      </div>
    );
  };

  const ActionButtons = () => {
    return (
      <div className="action-icons">
        <Tooltip title="Instant Call" placement="top" arrow>
          <span className="video-icon">
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FaVideo onClick={handleVideoClick} />
            )}
          </span>
        </Tooltip>
        {!isChatModal && (
          <MenuItems isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        )}
        {!isChatModal && isMobileView && (
          <span className="toggle-drawer-button" onClick={toggleDrawer}>
            <FaChevronRight />
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="chat-header-container tw">
      <Row className="chat-header align-items-center m-0">
        {isMobileView && (
          <Col className="back-button-col">
            <button
              onClick={onBack}
              className="back-button border rounded-lg px-2 py-1"
            >
              ← Back
            </button>
          </Col>
        )}
        <Col xs={isMobileView ? 10 : 12} className="chat-header-content">
          <div className="chat-header-inner">
            {isMobileView ? (
              <>
                <div className="chat-title-mobile font-semibold">
                  <h2 className="user-name">
                    {selectedConvo
                      ? selectedConvo?.createdBy !== user?.UserID
                        ? selectedConvo?.senderName?.trim() || "UnknownUser"
                        : selectedConvo?.customerName?.trim() || "UnknownUser"
                      : sampleAd && sampleAd?.firstName
                      ? `${sampleAd.firstName} ${
                          sampleAd.lastName || ""
                        }`.trim()
                      : sampleAd?.userName
                      ? sampleAd?.userName.split("@")[0].trim()
                      : sampleAd?.vendorName
                      ? sampleAd?.vendorName
                      : sampleAd?.Name?.split("@")[0].trim() || "UnknownUser"}
                  </h2>
                </div>
                <div className="chat-actions-mobile">
                  <div className="online-indicator-col">
                    <OnlineIndicator />
                  </div>
                  <ActionButtons />
                </div>
              </>
            ) : (
              <>
                <div className="chat-title-desktop">
                  <div className="chat-title-left">
                    <h2 className="user-name">
                      {selectedConvo
                        ? selectedConvo?.createdBy !== user?.UserID
                          ? selectedConvo?.senderName?.trim() || "UnknownUser"
                          : selectedConvo?.customerName?.trim() || "UnknownUser"
                        : sampleAd && sampleAd?.firstName
                        ? `${sampleAd.firstName} ${
                            sampleAd.lastName || ""
                          }`.trim()
                        : sampleAd?.userName
                        ? sampleAd?.userName.split("@")[0].trim()
                        : sampleAd?.vendorName
                        ? sampleAd?.vendorName
                        : sampleAd?.Name?.split("@")[0].trim() || "UnknownUser"}
                    </h2>
                    <OnlineIndicator />
                  </div>
                  <ActionButtons />
                </div>
                <div
                  className=""
                  style={{
                    color: "blue",
                  }}
                >
                  {typingStatus}
                </div>
              </>
            )}
          </div>
        </Col>
      </Row>
      {!isChatModal && selectedConvo?.postType === 3 && <AllDropdowns />}
    </div>
  );
};

export default ChatHeader;
